var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25829_8979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25 15.75C7.25 16.125 7.55 16.5 8 16.5H11C11.45 16.5 11.75 16.125 11.75 15.75V15H7.25V15.75ZM9.5 1.5C6.575 1.5 4.25 3.825 4.25 6.75C4.25 8.55 5.15 10.125 6.5 11.025V12.75C6.5 13.125 6.8 13.5 7.25 13.5H11.75C12.2 13.5 12.5 13.125 12.5 12.75V11.025C13.85 10.05 14.75 8.475 14.75 6.75C14.75 3.825 12.425 1.5 9.5 1.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25829_8979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.6cacdfe1b32de19225f17cd4d8f27366.svg";
export { ForwardRef as ReactComponent };